// extracted by css-extract-rspack-plugin
export default {"dialog":"PkMgT93rrY4eGbb6"};